import React, { useState } from 'react'
import { Empty, Modal, Skeleton, Table } from 'antd'
import moment from 'moment'
import { useGetEmailTrackingEventsByUserEmail } from 'graphQLHooks/customerManager/customerManagerHooks'
import { isEmpty } from 'lodash'
import './EmailTransactions.scss'
import { CUSTOM_AUDIT_VALUE_KEYS, DATE_FORMAT } from 'constants/general-constants'
// import InfiniteScroll from 'react-infinite-scroller'
// import FixedTableHeader from './FixedTableHeader'

const EVENTS_TYPE = {
  SENT: 'Send',
  DELIVERED: 'Delivery'
}

const limit = 5
const EmailTransactions = ({
  selectedCustomer,
  createAndFetchAuditEntry
}) => {
  const [selectedEvents, setSelectedEvents] = useState(null)
  const [selectedEmailBody, setSelectedEmailBody] = useState(false)
  const [showEmailBodyModal, setShowEmailBodyModal] = useState(false)
  const [showEventsModal, setShowEventsModal] = useState(false)
  const [deviceManagementTableScrollValue] = useState({ y: 'calc(100vh - 540px)', x: '95vw' })
  const {
    loading: isEmailListLoading,
    data: emailListData
    // fetchMore: refetchEmailList
  } = useGetEmailTrackingEventsByUserEmail({
    variables: {
      userEmail: selectedCustomer,
      emailType: '',
      limit
    }
  })
  const columns = [
    {
      title: 'Message ID',
      dataIndex: 'messageId',
      key: 'messageId',
      width: 40
    },
    {
      title: 'Message Type',
      dataIndex: 'emailType',
      key: 'emailType',
      width: 25
    },
    {
      title: 'Contents',
      dataIndex: 'emailBody',
      key: 'emailBody',
      render: (emailBody, row) => {
        const messageId = row?.messageId
        return (
          <>
            {
              emailBody
                ? (
                  <a
                    className='view-link'
                    onClick={() => {
                      setSelectedEmailBody(emailBody)
                      setShowEmailBodyModal(true)
                      setTimeout(() => {
                        createAndFetchAuditEntry(`${CUSTOM_AUDIT_VALUE_KEYS.EMAIL_CONTENTS} for message id ${messageId || '-'}`)
                      }, 500)
                    }}
                  >
                    View Email body
                  </a>
                )
                : 'Not Available'
            }
          </>

        )
      },
      width: 20
    },
    {
      title: 'Message Sent At',
      dataIndex: 'events',
      key: 'msg_sent_at',
      render: (events) => {
        const messageSentEvent = events?.find(event => event.eventType === EVENTS_TYPE.SENT)
        return (
          <p>{!isEmpty(messageSentEvent?.createdAt) ? moment(messageSentEvent.createdAt).format(DATE_FORMAT) : 'Not Sent'}</p>
        )
      },
      width: 30
    },
    {
      title: 'Message Delivered At',
      dataIndex: 'events',
      key: 'msg_del_at',
      render: (events) => {
        const messageDeliveryEvent = events?.find(event => event.eventType === EVENTS_TYPE.DELIVERED)
        return (
          <p>{!isEmpty(messageDeliveryEvent?.createdAt) ? moment(messageDeliveryEvent.createdAt).format(DATE_FORMAT) : 'Not Sent'}</p>
        )
      },
      width: 33
    },
    {
      title: 'Events',
      dataIndex: 'events',
      key: 'events',
      render: (events, row) => {
        const messageId = row?.messageId
        return (
          <div>
            <a
              onClick={(e) => {
                e.preventDefault()
                setShowEventsModal(true)
                setSelectedEvents(events)
                setTimeout(() => {
                  createAndFetchAuditEntry(`${CUSTOM_AUDIT_VALUE_KEYS.EVENTS} for message id ${messageId || '-'}`)
                }, 500)
              }}
              className='view-link'
            >
              View all Events
            </a>
          </div>
        )
      },
      width: 20
    },
    {
      title: 'Record Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 30,
      render: (value) => {
        return <span> {moment(value).format(DATE_FORMAT)}</span>
      }
    },
    {
      title: 'Record Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 30,
      render: (value) => {
        return <span> {moment(value).format(DATE_FORMAT)}</span>
      },
      className: 'non-action-table-row'
    }
    // {
    //   width: '2%',
    //   title: '',
    //   key: 'action',
    //   render: (details) => {
    //     const rowId = details?.id
    //     return (
    //       <div className='option-list' id='option-list-container'>
    //         <Popover
    //           content={
    //             actionMenuOptions.map(item => {
    //               return (
    //                 <p
    //                   onClick={() => {
    //                     toggleActionMenu(item)
    //                     handleSelectedRowDetails(details)
    //                     handleOpenCloseToggleMenu(rowId, false)
    //                   }}
    //                 >
    //                   {item.name}
    //                 </p>
    //               )
    //             })
    //           }
    //           title={null}
    //           trigger='click'
    //           visible={deviceTableToggleMenuItems?.[rowId]}
    //           onVisibleChange={(flag) => handleOpenCloseToggleMenu(rowId, flag)}
    //           placement='left'
    //         >
    //           <div><ExpandMenuIcon /></div>
    //         </Popover>
    //       </div>
    //     )
    //   }
    // }
  ]
  const tableData = emailListData?.getEmailTrackingEventsByUserEmail
  return (
    <div className='email-details-container'>
      <div className='email-table-wrapper'>
        {
          isEmailListLoading
            ? <Skeleton />
            : (
              <div className='email-details-table' id='email-details-table'>
                {
                  !isEmpty(tableData?.data)
                    ? (
                      <>
                        {/* <FixedTableHeader columnCellList={columns} />
                        <InfiniteScroll
                          pageStart={0}
                          loadMore={() => {
                            if (!isEmailListLoading) {
                              refetchEmailList({
                                variables: {
                                  userEmail: selectedCustomer,
                                  emailType: '',
                                  limit,
                                  nextToken: tableData.nextToken
                                },
                                updateQuery: (prev, { fetchMoreResult }) => {
                                  return {
                                    ...prev,
                                    getEmailTrackingEventsByUserEmail: {
                                      ...fetchMoreResult.getEmailTrackingEventsByUserEmail,
                                      data: [
                                        ...prev.getEmailTrackingEventsByUserEmail.data,
                                        ...fetchMoreResult.getEmailTrackingEventsByUserEmail.data
                                      ]
                                    }
                                  }
                                }
                              })
                            }
                          }}
                          initialLoad={false}
                          useWindow={false}
                          hasMore={!isEmpty(tableData.nextToken)}
                          getScrollParent={() => document.getElementById('email-details-table')}
                        > */}
                        <Table
                          className='general-table'
                          columns={columns}
                          dataSource={tableData?.data}
                          bordered
                          pagination={false}
                          scroll={deviceManagementTableScrollValue}
                        />
                        {/* <Skeleton active avatar={false} title paragraph={{ rows: 1 }} loading={isEmailListLoading} />
                        </InfiniteScroll> */}
                      </>
                    )
                    : <Empty />
                }

              </div>
            )
        }
      </div>
      <Modal
        title='View Events'
        visible={showEventsModal}
        onOk={() => {
          setShowEventsModal(false)
        }}
        onCancel={() => {
          setShowEventsModal(false)
        }}
        className='general-modal'
        cancelButtonProps={{ style: { display: 'none' } }}
        // width='calc(100vw - 80px)'
      >
        <div>
          <Table
            className='general-table'
            columns={[
              {
                title: 'Event Type',
                dataIndex: 'eventType',
                key: 'eventType',
                width: 20
              },
              {
                title: 'Created At',
                dataIndex: 'createdAt',
                key: 'createdAt',
                width: 25,
                className: 'non-action-table-row',
                render: (value) => {
                  return <span> {moment(value).format(DATE_FORMAT)}</span>
                }
              }
            ]}
            dataSource={selectedEvents}
            bordered
            pagination={false}
            // scroll={deviceManagementTableScrollValue}
          />
        </div>
      </Modal>
      <Modal
        title='Email Body'
        visible={showEmailBodyModal}
        onOk={() => {
          setShowEmailBodyModal(false)
        }}
        onCancel={() => {
          setShowEmailBodyModal(false)
        }}
        className='general-modal email-body-modal'
        width='calc(100vw - 80px)'
        cancelButtonProps={{ style: { display: 'none' } }}
      >

        <iframe src={selectedEmailBody} frameborder='0' />
        {/* <div className='email-body-content' dangerouslySetInnerHTML={{ __html: selectedEmailBody }} /> */}
      </Modal>
    </div>
  )
}

export default EmailTransactions
